<template>
  <v-content>
    <the-header menuTitle="Campaign"/>
    <v-container class="page-wrapper scroll-y"  id = "scroll-target"
        :style="{ maxHeight: winHeight, backgroundColor: 'white' }">

      	<List id="scrolled-content"></List> 
    </v-container>
    <!--  <the-footer style="margin-bottom:-44px" /> -->

  </v-content>

</template>

<script>
 // 
  import TheHeader from "@/components/TheHeader";
  import TheFooter from "@/components/TheFooter";
  import List from '@/components/List'
  
 
  export default {
    name:'detail',
    components: {
      TheHeader,
      TheFooter,
      List,
     
    },
     data () {
      return {
        winHeight: window.innerHeight *0.9 + "px",
        container: null,
        elem: null,
        scrollTop: 400
        //dialog: false
      }
    },
  updated(){
      
  },
   mounted(){
    this.elem = document.getElementById ( "scrolled-content" )
    this.container = document.getElementById ( "scroll-target" )
    this.container.scrollTop = Math.floor ( this.elem.offsetHeight )
     
    //  console.log(this.$store.state.isLoading);
//     (23018) (REPORT)MY/Honda/HEV Sustenance Mar'18 
// (22987) (REPORT)MY/Honda/City PET Sustenance Mar'18
// (22946) (REPORT)MY/Honda/CRV Sustenance Mar'18 
      // this.dialog = this.$store.state.isLoading
      // console.log(this.dialog)
    },
    watch: {
      dialog (val) {
        if (!val) return

        setTimeout(() => (this.dialog = false), 1000)
      }
    }
    
   
    
   
  }
</script>